import useEntity from "../../hooks/useRoadCarrier";
import RoadCarrierDetail from "../../components/roadCarrier/RoadCarrierDetail/RoadCarrierDetail";
import RoadCarrierScoped from "../../components/roadCarrier/RoadCarrierDetail/RoadCarrierScoped";
import RoadCarrierTabs from "../../components/roadCarrier/RoadCarrierDetail/RoadCarrierTabs";
import { useGetRoadCarrierQuery } from "../../apis/RoadCarrier.api";
import { PrimaryRoadCarrier } from "../../types/models/RoadCarrier";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const RoadCarrierDetailPage = () => {

    useTitle(t`Details Road Carrier`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { roadCarrierId: id } = useParams();

    const { data, refetch } = useGetRoadCarrierQuery(PrimaryRoadCarrier.fromPath(id))
    const { deleteRoadCarrier } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteRoadCarrier(data, '..')
    }, [data, deleteRoadCarrier])

    if (id === 'scoped') {
        return (<RoadCarrierScoped/>)
    }

    return (
        <Box data-testid="RoadCarrier-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <RoadCarrierDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/RoadCarriers/update/view'
        ) ||
false) &&
                        <Button size="small" variant="outlined" data-testid="RoadCarrier-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/RoadCarriers/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="RoadCarrier-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <RoadCarrierTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default RoadCarrierDetailPage;
